import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthLayout from 'pages/_layouts/auth';
import DefaultLayout from 'pages/_layouts/default';
import Minimallayout from 'pages/_layouts/minimal';
import { useSelector } from 'react-redux';
import { store } from 'store';
import { Role } from 'utils/variables';

export default function PrivateRoute({ children, isPrivate = false }) {
  const location = useLocation();

  const token = useSelector(state => state.auth.token);
  const role = store.getState().usuario?.profile?.role;

  // 🔒 Not signed but route requires auth
  if (!token && isPrivate) {
    return <Navigate to="/" replace />;
  }

  // 🔁 Signed but accessing public route (e.g. login)
  if (token && !isPrivate) {
    let redirect = '/dashboard';

    switch (role) {
      case Role.CEDOC:
        redirect = '/arquivamento';
        break;
      case Role.JORN:
        redirect = '/solicitacaochamada';
        break;
      case Role.MKT:
        redirect = '/melhoriadobreak';
        break;
      case Role.EXEC:
        redirect = '/criativos';
        break;
      case Role.PROMO:
      case Role.PROG:
        redirect = '/chamadas';
        break;
    }

    return <Navigate to={redirect} replace />;
  }

  // 🧱 Choose layout
  const Layout = token
    ? location.pathname.includes('/closedcaptioneditor')
      ? Minimallayout
      : DefaultLayout
    : AuthLayout;

  return <Layout>{children}</Layout>;
}
